import { createReducer, on } from '@ngrx/store';
import * as Actions from './agent-applications.actions';
import {
  handleClear,
  handleFailure,
  handleRequest,
  handleSuccess,
} from '@shared/ngrx-factory/factory.reducer';

const initialRequestState: Actions.RequestState<any> = {
  loading: false,
  message: null,
  response: null,
  error: null,
};

export const initialAgentApplicationsState: Actions.AgentApplicationsState = {
  list: { ...initialRequestState },
  details: { ...initialRequestState },
  agentTypes: { ...initialRequestState },
};

export const agentApplicationsReducer = createReducer(
  initialAgentApplicationsState,

  // List Agent Registrations
  on(Actions.ListAgentRegistrationsActions.request, (state) =>
    handleRequest(state, 'list'),
  ),
  on(Actions.ListAgentRegistrationsActions.success, (state, { response }) =>
    handleSuccess(state, 'list', response),
  ),
  on(Actions.ListAgentRegistrationsActions.failure, (state, { error }) =>
    handleFailure(state, 'list', error),
  ),
  on(Actions.ListAgentRegistrationsActions.clearState, (state) =>
    handleClear(state, 'list'),
  ),

  // Get Agent Registration Details
  on(Actions.GetAgentRegistrationActions.request, (state) =>
    handleRequest(state, 'details'),
  ),
  on(Actions.GetAgentRegistrationActions.success, (state, { response }) =>
    handleSuccess(state, 'details', response),
  ),
  on(Actions.GetAgentRegistrationActions.failure, (state, { error }) =>
    handleFailure(state, 'details', error),
  ),
  on(Actions.GetAgentRegistrationActions.clearState, (state) =>
    handleClear(state, 'details'),
  ),

  // Get Agent Types
  on(Actions.GetAgentTypesActions.request, (state) =>
    handleRequest(state, 'agentTypes'),
  ),
  on(Actions.GetAgentTypesActions.success, (state, { response }) =>
    handleSuccess(state, 'agentTypes', response),
  ),
  on(Actions.GetAgentTypesActions.failure, (state, { error }) =>
    handleFailure(state, 'agentTypes', error),
  ),
  on(Actions.GetAgentTypesActions.clearState, (state) =>
    handleClear(state, 'agentTypes'),
  ),

  // Clear Context
  on(Actions.clearAgentApplicationsContext, () => ({
    ...initialAgentApplicationsState,
  })),
);
